'use client'

import { IChildrenProps } from '@/utils/typings/children-props'
import { createContext, useContext } from 'react'

export type INodeMoveActionAs = 'context-menu' | 'dropdown-menu'

interface INodeMoveActionContext {
    path: string
    level: number
    name: string
    isEntrypoint?: boolean
    onSuccess?: () => void
    mode: 'node' | 'selected'
    as: INodeMoveActionAs
    styleType?: 'light' | 'dark'
    disabled?: boolean
}

const NodeMoveActionContext = createContext<INodeMoveActionContext | null>(null)

export type INodeMoveActionContextProviderProps = IChildrenProps & INodeMoveActionContext

export const NodeMoveActionContextProvider = ({
    children,
    styleType = 'light',
    disabled = false,
    ...props
}: INodeMoveActionContextProviderProps) => {
    return (
        <NodeMoveActionContext.Provider value={{ ...props, styleType, disabled }}>
            {children}
        </NodeMoveActionContext.Provider>
    )
}

export const useNodeMoveActionContext = () => {
    const context = useContext(NodeMoveActionContext)

    if (!context) {
        throw new Error('useNodeMoveActionContext must be used within a NodeMoveActionContextProvider')
    }

    return context
}
